import GroupInterface from "../../interfaces/GroupInterface";

function groupFactory({
  id,
  name,
  limit,
  devices,
  activeDeviceCount,
  currentlyUsed,
}: GroupInterface): GroupInterface {
  return Object.freeze({
    id,
    name,
    limit,
    devices: devices ?? [],
    currentlyUsed,
    activeDeviceCount,
    get allDeviceCount() {
      return this.devices?.length ?? 0;
    },
  });
}

export default groupFactory;
